(() => {
  const WRAP_SELECTOR = ".grizzly-search-wrap";
  const INPUT_SELECTOR = ".grizzly-search__input";

  // Shopify suggest endpoint (works on all themes)
  const buildUrl = (q) => {
    const params = new URLSearchParams();
    params.set("q", q);
    params.set("resources[type]", "product");
    params.set("resources[limit]", "8");
    params.set("resources[options][unavailable_products]", "hide");
    params.set("resources[options][fields]", "title,product_type,vendor");
    return `/search/suggest.json?${params.toString()}`;
  };

  const debounce = (fn, ms = 180) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  };

  function ensureDropdown(wrap) {
    let dd = wrap.querySelector(".grizzly-predictive-dd");
    if (!dd) {
      dd = document.createElement("div");
      dd.className = "grizzly-predictive-dd";
      dd.setAttribute("role", "listbox");
      dd.innerHTML = `<div class="grizzly-predictive-dd__inner"></div>`;
      wrap.appendChild(dd);
    }
    return dd.querySelector(".grizzly-predictive-dd__inner");
  }

  function clearDropdown(wrap) {
    const inner = wrap.querySelector(".grizzly-predictive-dd__inner");
    if (inner) inner.innerHTML = "";
    wrap.classList.remove("grizzly-dd-open");
  }

  async function fetchSuggestions(q) {
    const res = await fetch(buildUrl(q), { headers: { "Accept": "application/json" } });
    if (!res.ok) return [];
    const json = await res.json();
    const products = json?.resources?.results?.products || [];
    return products;
  }

  function render(wrap, products, q) {
    const inner = ensureDropdown(wrap);

    if (!products.length) {
      inner.innerHTML = `
        <div class="grizzly-dd-empty">
          No results. Press Enter to search for “${escapeHtml(q)}”
        </div>`;
      wrap.classList.add("grizzly-dd-open");
      return;
    }

    inner.innerHTML = products.map((p, idx) => {
      const title = escapeHtml(p.title || "");
      const url = p.url || "#";
      const vendor = escapeHtml(p.vendor || "");
      const type = escapeHtml(p.product_type || "");
      const meta = [vendor, type].filter(Boolean).join(" • ");

      return `
        <a class="grizzly-dd-item" role="option" aria-selected="false" href="${url}" data-idx="${idx}">
          <div class="grizzly-dd-item__title">${title}</div>
          ${meta ? `<div class="grizzly-dd-item__meta">${meta}</div>` : ``}
        </a>`;
    }).join("");

    wrap.classList.add("grizzly-dd-open");
  }

  function escapeHtml(s) {
    return String(s)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function attach(wrap) {
    const input = wrap.querySelector(INPUT_SELECTOR);
    if (!input) return;

    const run = debounce(async () => {
      const q = (input.value || "").trim();
      if (q.length < 2) {
        clearDropdown(wrap);
        return;
      }
      const products = await fetchSuggestions(q);
      render(wrap, products, q);
    }, 180);

    input.addEventListener("input", run);

    input.addEventListener("focus", () => {
      if ((input.value || "").trim().length >= 2) run();
    });

    document.addEventListener("click", (e) => {
      if (!wrap.contains(e.target)) clearDropdown(wrap);
    });

    input.form?.addEventListener("submit", () => clearDropdown(wrap));
  }

  // Attach to all instances (desktop + mobile)
  document.querySelectorAll(WRAP_SELECTOR).forEach(attach);
})();